export default ['TODOS', 'ADULTO', 'PEDIATRIA']
